const CheckType = {
  PERSONAL: 'PERSONAL',
  CERTIFIED: 'CERTIFIED',
  _Values: () =>
    Object.keys(CheckType)
      .filter(key => typeof CheckType[key] !== 'function')
      .map(key => CheckType[key]),
};

const CheckSides = {
  BACK: 'back',
  FRONT: 'front',
  _Values: () =>
    Object.keys(CheckSides)
      .filter(key => typeof CheckSides[key] !== 'function')
      .map(key => CheckSides[key]),
};

const PaymentGateway = {
  VANTIV: 'VANTIV',
  CHECK21: 'CHECK21',
  _Values: () =>
    Object.keys(PaymentGateway)
      .filter(key => typeof PaymentGateway[key] !== 'function')
      .map(key => PaymentGateway[key]),
};

const DisbursementPlatform = {
  VANTIV: 'VANTIV',
  CHECK21: 'CHECK21',
  KYCK_GLOBAL: 'KYCK_GLOBAL',
  _Values: () =>
    Object.keys(DisbursementPlatform)
      .filter(key => typeof DisbursementPlatform[key] !== 'function')
      .map(key => DisbursementPlatform[key]),
};

const AllowedPaymentMethod = {
  DO_NOT_ACCEPT: 'DO_NOT_ACCEPT_PAYMENT',
  CASH_EQUIVALENT: 'CASH_EQUIVALENT',
  _Values: () =>
    Object.keys(AllowedPaymentMethod)
      .filter(key => typeof AllowedPaymentMethod[key] !== 'function')
      .map(key => AllowedPaymentMethod[key]),
};

const DefaultMaxCheckAmount = 500000;

const PaymentStatus = {
  AUTHORIZED: 'AUTHORIZED',
  APPROVED: 'APPROVED',
  _Values: () =>
    Object.keys(PaymentStatus)
      .filter(key => typeof PaymentStatus[key] !== 'function')
      .map(key => PaymentStatus[key]),
};

module.exports = {
  CheckType,
  CheckSides,
  PaymentGateway,
  DisbursementPlatform,
  AllowedPaymentMethod,
  DefaultMaxCheckAmount,
  PaymentStatus,
};
